import React from 'react';
import PropTypes from 'prop-types';
import { MdEdit } from 'react-icons/md';

import { Icon } from './styles';
import ds from '../../../utils/designSystem';

export default function EditButton(props) {
  return (
    <Icon data-testid="edit-button" onClick={props.onClick} type="button">
      <MdEdit color={ds.colors.blueDark} size={20} />
    </Icon>
  );
}

EditButton.propTypes = {
  onClick: PropTypes.func
};
